
import { AssignAgentComponent } from '../../Views/Home/AssignAgentView/AssignAgentComponent' ;

export const LeadOwnerAssignAgentRoutes = [
    {
        path: '/view',
        name: 'leadOwnerView:AssignAgent',
        component: AssignAgentComponent,
        layout: '/home/lead-owner-assign-agent',
        default: true,
        isRoute: true,
        authorize: true,
        roles: [],
        isDisabled: false,
        isExact: true,
        breadcrumbs: [
          {
            name: 'leadOwnerView:AssignAgent',
            isDisabled: true,
            route: 'home/lead-owner-assign-agent/view',
            groupName: 'lead-owner',
          },
        ],
    }
  ];

